import type Alpine from "alpinejs";

/**
 * Pointer-drag-to-scroll for horizontal scroll strips.
 * Looks for `.cucina-strip__track` and wires pointerdown / move / up.
 */
export function registerStrip(A: typeof Alpine) {
  A.data("momaStrip", () => ({
    dragging: false,
    startX: 0,
    startScroll: 0,

    init() {
      const track = (this.$refs as Record<string, HTMLElement>).track;
      if (!track) return;

      const down = (e: PointerEvent) => {
        if (e.pointerType === "touch") return;
        this.dragging = true;
        this.startX = e.clientX;
        this.startScroll = track.scrollLeft;
        track.setPointerCapture(e.pointerId);
        track.classList.add("is-dragging");
      };
      const move = (e: PointerEvent) => {
        if (!this.dragging) return;
        track.scrollLeft = this.startScroll - (e.clientX - this.startX);
      };
      const up = (e: PointerEvent) => {
        if (!this.dragging) return;
        this.dragging = false;
        try {
          track.releasePointerCapture(e.pointerId);
        } catch {
          /* noop */
        }
        track.classList.remove("is-dragging");
      };
      track.addEventListener("pointerdown", down);
      track.addEventListener("pointermove", move);
      track.addEventListener("pointerup", up);
      track.addEventListener("pointercancel", up);
      track.addEventListener("pointerleave", up);
    },
  }));
}
